module.exports = __webpack_public_path__ + "img/hoodie3.cd66f13b.webp";